"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const assets_1 = require("../assets");
const styles_1 = require("../styles");
const BottomSheet_1 = __importDefault(require("./BottomSheet"));
const RadioButton_1 = __importDefault(require("./RadioButton"));
const Button_1 = __importDefault(require("./Button"));
const Text_1 = __importDefault(require("./Text"));
const ChevronLeftIcon_1 = __importDefault(require("../icons/ChevronLeftIcon"));
const PickerItem = ({ _noRadioButton, label, value, _onPress, _selectedValue, _noTopBorder = false, }) => (react_1.default.createElement(react_native_1.TouchableOpacity, { style: react_native_1.StyleSheet.flatten([itemStyles.container, !_noTopBorder && itemStyles.topBorder]), onPress: () => {
        _onPress && _onPress({ label, value });
    } },
    !_noRadioButton && react_1.default.createElement(RadioButton_1.default, { disabled: true, selected: _selectedValue === value, style: itemStyles.radio }),
    react_1.default.createElement(Text_1.default, { style: styles.text, margin: "none", color: value === _selectedValue ? 'primary' : 'default' }, label)));
const itemStyles = react_native_1.StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: styles_1.getSpacing(),
        alignSelf: 'flex-start',
    },
    topBorder: {
        borderTopWidth: assets_1.Shape.borderWidth,
        borderTopColor: styles_1.Colors.border,
        width: '100%',
    },
    radio: {
        marginRight: styles_1.getSpacing(),
    },
});
const handleItems = (items = [], noRadioButton, selectedValue, onSelectValue) => {
    let arrayItems;
    if (!Array.isArray(items)) {
        arrayItems = [items];
    }
    else {
        arrayItems = items;
    }
    return (react_1.default.createElement(react_native_1.FlatList, { data: arrayItems, keyExtractor: (_, index) => `pickerItem-${index}`, renderItem: ({ item, index }) => {
            return (react_1.default.createElement(PickerItem, { key: `pickerItems${item.props.value}`, _selectedValue: selectedValue, _onPress: (val) => {
                    onSelectValue && onSelectValue(val);
                }, _noRadioButton: noRadioButton, _noTopBorder: index === 0, label: item.props.label, value: item.props.value }));
        } }));
};
const handleLabel = (items = [], selectedValue) => {
    if (!Array.isArray(items)) {
        items = [items];
    }
    for (let i = 0; i < items.length; i++) {
        if (selectedValue === items[i].props.value) {
            return items[i].props.label;
        }
    }
    return '';
};
const Picker = ({ marginBottom = styles_1.getSpacing(), customIcon, placeholder, contentHeader, onSelectValue, selectedValue = '', noRadioButton = false, color = 'default', variant = 'contained', children, disabled, hideSelectedValue = false, label, style, onSelectLabel, }) => {
    const [bottomSheetIsVisible, setBottomSheetIsVisible] = react_1.useState(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(BottomSheet_1.default, { visible: bottomSheetIsVisible, contentHeader: contentHeader, onRequestClose: () => {
                setBottomSheetIsVisible(false);
            } }, handleItems(children, noRadioButton, selectedValue, (val) => {
            setBottomSheetIsVisible(false);
            onSelectValue && onSelectValue(val.value);
            onSelectLabel && onSelectLabel(val.label);
        })),
        react_1.default.createElement(Button_1.default, { disabled: disabled, variant: variant, color: color, style: react_native_1.StyleSheet.flatten([styles.buttonStyle, { marginBottom }, disabled && styles.disabled, style]), onPress: () => {
                setBottomSheetIsVisible(true);
            } },
            react_1.default.createElement(react_native_1.View, { style: styles.descriptionContainer },
                !selectedValue && !!placeholder && (react_1.default.createElement(Text_1.default, { margin: "none", color: "disabled" }, placeholder)),
                !!label && !!selectedValue && (react_1.default.createElement(Text_1.default, { margin: "none", color: "description", style: styles.label },
                    label,
                    ":")),
                !hideSelectedValue && (react_1.default.createElement(Text_1.default, { margin: "none", numberOfLines: 1 }, handleLabel(children, selectedValue)))),
            !customIcon && !disabled && (react_1.default.createElement(react_native_1.View, { style: styles.chevron },
                react_1.default.createElement(ChevronLeftIcon_1.default, { style: styles.icon, stroke: styles_1.Colors.primary }))),
            customIcon)));
};
Picker.Item = PickerItem;
exports.default = Picker;
const styles = react_native_1.StyleSheet.create({
    buttonStyle: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: styles_1.getSpacing(),
    },
    disabled: {
        borderColor: styles_1.Colors.border,
        backgroundColor: styles_1.Colors.card,
    },
    text: {
        // flex: 1,
        width: '95%',
        textAlign: 'justify',
    },
    descriptionContainer: { flexDirection: 'row', maxWidth: '90%' },
    label: {
        marginBottom: 0,
        marginRight: styles_1.getSpacing(0.5),
    },
    buttonTextView: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    icon: {
        width: 20,
        height: 20,
    },
    chevron: {
        transform: [{ rotate: '-90deg' }],
    },
});
